import './proxima-nova/index.css';
import './whitney-semibold/index.css';

export const PRIMARY_FONT = 'proxima-nova';
export const SECONDARY_FONT = 'Whitney-Semibold';
